import { action, props } from 'ts-action';
import { SkipHistory } from '../../undo/actions/undo.actions';
import { Label, AssessmentStatus } from '../types/label';
import { Abnormality } from '../../diagnostic/types/diagnostic';

export const setAutoLabels = action(
  '[AutoLabels] setAutoLabels',
  props<
    {
      labelsToRemove: Label[];
      labelsToAdd: Label[];
    } & SkipHistory
  >(),
);

export const setAssessmentStatus = action(
  '[AutoLabels] setAssessmentStatus',
  props<{ status: AssessmentStatus } & SkipHistory>(),
);

export const setCodeSeen = action(
  '[AutoLabels] setCodeSeen',
  props<
    { codeToAddSeen: string[]; codeToRemoveSeen: string[] } & SkipHistory
  >(),
);

export const toggleCodeAssessment = action(
  '[AutoLabels] toggleCodeAssessment',
  props<{ code: string } & SkipHistory>(),
);

export const addAssessmentLogs = action(
  '[AutoLabels] addAssessmentLogs',
  props<
    {
      labelsToRemove: Label[];
      labelsToAdd: Label[];
      abnormalities: Abnormality[];
    } & SkipHistory
  >(),
);
